import { useReducer, useCallback } from 'react';

export interface FormState {
  email: string;
  password: string;
  cpassword: string;
  phone: string;
  terms: boolean;
  ccg: boolean;
  isTdae: boolean;
  firstName?: string;
  lastName?: string;
  gender?: string;
  birthday?: any;
  courses?: any[];
  sponsorship?: string;
  recommandedBy?: string;
  option?: number;
  showPass: false,
  showCPass? : boolean
  remember? : boolean
  loading? : boolean
}

export interface FormErrors {
  email?: string;
  password?: string;
  phone?: string;
  terms?: string;
  ccg?: string;
  firstName?: string;
  lastName?: string;
  gender?: string;
  birthday?: string;
  courses?: string;
  sponsorship?: string;
  homeCoursesOnly?: string;
  numberOfStudents?: string;
  wantsAdvice?: string;
}

type FormAction =
  | { type: 'SET_FIELD'; field: keyof FormState; value: any }
  | { type: 'SET_ERRORS'; errors: Partial<FormErrors> }
  | { type: 'CLEAR_ERROR'; field: keyof FormErrors }
  | { type: 'RESET_FORM' }
  | { type: 'SET_FORM'; form: Partial<FormState> };

interface FormReducerState {
  form: FormState;
  errors: FormErrors;
}

const initialState: FormReducerState = {
  form: {
    email: '',
    password: '',
    cpassword: '',
    phone: '',
    terms: false,
    ccg: false,
    isTdae: false,
    showPass : false,
    showCPass : false,
    remember: false,
    loading: false,

  },
  errors: {},
};

function formReducer(
  state: FormReducerState,
  action: FormAction
): FormReducerState {
  switch (action.type) {
    case 'SET_FIELD':
      return {
        ...state,
        form: {
          ...state.form,
          [action.field]: action.value,
        },
      };
    case 'SET_ERRORS':
      return {
        ...state,
        errors: {
          ...state.errors,
          ...action.errors,
        },
      };
    case 'CLEAR_ERROR':
      const { [action.field]: _, ...restErrors } = state.errors;
      return {
        ...state,
        errors: restErrors,
      };
    case 'RESET_FORM':
      return initialState;
    case 'SET_FORM':
      return {
        ...state,
        form: {
          ...state.form,
          ...action.form,
        },
      };
    default:
      return state;
  }
}

export function useFormState(initialForm?: Partial<FormState>) {
  const [state, dispatch] = useReducer(formReducer, {
    ...initialState,
    form: {
      ...initialState.form,
      ...initialForm,
    },
  });

  const setField = useCallback((field: keyof FormState, value: any) => {
    dispatch({ type: 'SET_FIELD', field, value });
  }, []);

  const setErrors = useCallback((errors: Partial<FormErrors>) => {
    dispatch({ type: 'SET_ERRORS', errors });
  }, []);

  const clearError = useCallback((field: keyof FormErrors) => {
    dispatch({ type: 'CLEAR_ERROR', field });
  }, []);

  const resetForm = useCallback(() => {
    dispatch({ type: 'RESET_FORM' });
  }, []);

  const setForm = useCallback((form: Partial<FormState>) => {
    dispatch({ type: 'SET_FORM', form });
  }, []);

  return {
    form: state.form,
    errors: state.errors,
    setField,
    setErrors,
    clearError,
    resetForm,
    setForm,
  };
}




